import styles from './index.scss'
import xialaIco from './xiala_ico.png'
import { Button } from 'antd-mobile'
import React, { useState, FC } from 'react'
import iconSelected from './xuanzhong.png'
import iconUnSelected from './buxuanzhong.png'
import successSvg from './successSvg'
import { SvgRadioSuccessIcon } from '@/libs/components/Icon/svgIcon'
import { CheckCircleFill } from 'antd-mobile-icons'
import { TrackView } from '@dragonpass/intl-unified-tracker'

type DiscountCouponCardPropsType = {
  onConfirm?: () => void
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' | 'quota' // 优惠卷类型：折扣 满减 定额
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额（discount 类型用来显示"最多抵xx"）
    cuoDiscount: number // 折扣（discount）/ 优惠金额（reduce/quota）
    couponTypeName?: string // 优惠券类型名称，用于右上角展示
  }
  color?: string
  /** 货币符号，默认 ¥；多币种场景可传入 MOP / US$ 等 */
  currencySymbol?: string
}

// 去使用的效果的优惠券
export default function DiscountCouponCard(props: DiscountCouponCardPropsType) {
  const { onConfirm = () => { }, data, color = '', currencySymbol = '¥' } = props
  const {
    expirationStart,
    expirationEnd,
    instructions,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
    couponTypeName,
  } = data

  const [open, setOpen] = useState<any>(false)

  // condition 文案：
  // discount 折扣券 → "最多抵{cuoMaxAmount}"（优惠上限为空则不展示）
  // quota 定额券 → "{cuoDiscount}兑换"（兑换金额取 cuoDiscount，文案固定为"兑换"）
  // reduce 满减券 → "满{couBarriersAmount}可用" 或 "无门槛"（barriersAmount 为 0 即无门槛）
  const conditionText = (() => {
    if (couponType === 'discount') {
      return cuoMaxAmount ? `最多抵${cuoMaxAmount}` : ''
    }
    if (couponType === 'quota') {
      return `${cuoDiscount}兑换`
    }
    // reduce
    if (!couBarriersAmount) {
      return '无门槛'
    }
    return `满${couBarriersAmount}可用`
  })()

  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        {conditionText && <div className={styles.condition}>{conditionText}</div>}
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          <span>{currencySymbol}</span>{cuoDiscount}
        </div>
        <div className={styles.condition}>{conditionText}</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          <span>{currencySymbol}</span>{cuoDiscount}
        </div>
        <div className={styles.condition}>{conditionText}</div>
      </div>
    ),
  }

  return (
    <div className={styles.discountCouponCard}>
      {couponTypeName && <div className={styles.couponTypeNameTag}>{couponTypeName}</div>}
      <div className={styles.upperPart}>
        {DiscountsComponents[couponType]}
        <div className={styles.info}>
          <div className={styles.name}>{cuoName}</div>
          <div className={styles.date}>
            {expirationStart} 至 {expirationEnd}
          </div>
        </div>
      </div>
      <div className={styles.nextPart}>
        <div className={styles.explainTitle} onClick={() => setOpen(!open)}>
          使用说明
          <img
            src={xialaIco}
            className={`${styles.icon} ${open ? styles.open : ''}`}
          />
        </div>
        <Button
          className={styles.btn}
          shape="rounded"
          type="submit"
          color="primary"
          size="small"
          onClick={onConfirm}
        >
          去使用
        </Button>
      </div>
      <div
        className={styles.explainContent}
        style={{ display: open ? 'block' : 'none' }}
      >
        {!!cuoMaxAmount && couponType === 'discount' && (
          <>
            最高可优惠{currencySymbol}{cuoMaxAmount}<br />
          </>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: instructions }}
        ></div>
      </div>
    </div>
  )
}

type SelectDiscountCouponCardPropsType = {
  onSelect?: () => void
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' | 'quota' // 优惠卷类型：折扣 满减 定额
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额（discount 类型用来显示"最多抵xx"）
    cuoDiscount: number // 折扣（discount）/ 优惠金额（reduce/quota）
    couponTypeName?: string // 优惠券类型名称，用于右上角展示
  }
  check?: boolean // 是否选中,
  containerStyles?: React.CSSProperties
  color?: string;
  categoryType?: string
  trackClk?: boolean
  trackExp?: boolean
  trackData?: {
    [key: string]: any
  }
  /** 货币符号，默认 ¥；多币种场景可传入 MOP / US$ 等 */
  currencySymbol?: string
}

// 勾选的效果的优惠券
export function SelectDiscountCouponCard(
  props: SelectDiscountCouponCardPropsType,
) {
  const { onSelect = () => { }, data, check, color = '', trackClk = false, trackExp = false, trackData = {}, currencySymbol = '¥' } = props
  const {
    expirationStart,
    expirationEnd,
    instructions,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
    couponTypeName,
  } = data

  const [open, setOpen] = useState<any>(false)

  const CheckIco = (props: any) => {
    const { check } = props
    return !!check ? (
      <CheckCircleFill
        style={{ color: props?.color || 'var(--certify-primary-color)' }}
        fontSize={20}
      />
    ) : (
      <img src={iconUnSelected} className={styles.icon} />
    )
  }

  // condition 文案：
  // discount 折扣券 → "最多抵{cuoMaxAmount}"（优惠上限为空则不展示）
  // quota 定额券 → "{cuoDiscount}兑换"（兑换金额取 cuoDiscount，文案固定为"兑换"）
  // reduce 满减券 → "满{couBarriersAmount}可用" 或 "无门槛"（barriersAmount 为 0 即无门槛）
  const conditionText = (() => {
    if (couponType === 'discount') {
      return cuoMaxAmount ? `最多抵${cuoMaxAmount}` : ''
    }
    if (couponType === 'quota') {
      return `${cuoDiscount}兑换`
    }
    // reduce
    if (!couBarriersAmount) {
      return '无门槛'
    }
    return `满${couBarriersAmount}可用`
  })()

  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        {conditionText && <div className={styles.condition}>{conditionText}</div>}
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          <span>{currencySymbol}</span>{cuoDiscount}
        </div>
        <div className={styles.condition}>{conditionText}</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          <span>{currencySymbol}</span>{cuoDiscount}
        </div>
        <div className={styles.condition}>{conditionText}</div>
      </div>
    ),
  }

  return (
    <div className={styles.discountCouponCard} style={props?.containerStyles}>
      {couponTypeName && <div className={styles.couponTypeNameTag}>{couponTypeName}</div>}
      <TrackView
        trackData={trackData}
        trackClk={trackClk}
        trackExp={trackExp}
      >
        <div className={styles.upperPart} onClick={onSelect}>
          {DiscountsComponents[couponType]}
          <div className={styles.info}>
            <div className={styles.name}>{cuoName}</div>
            <div className={styles.date}>
              {expirationStart} 至 {expirationEnd}
            </div>
          </div>
          <CheckIco check={check} {...props} />
        </div>
      </TrackView>
      <div className={styles.nextPart}>
        <div className={styles.explainTitle} onClick={() => setOpen(!open)}>
          使用说明
          <img
            src={xialaIco}
            className={`${styles.icon} ${open ? styles.open : ''}`}
          />
        </div>
      </div>
      <div
        className={styles.explainContent}
        style={{ display: open ? 'block' : 'none' }}
      >
        {!!cuoMaxAmount && couponType === 'discount' && (
          <>
            最高可优惠{currencySymbol}{cuoMaxAmount}<br />
          </>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: instructions }}
        ></div>
      </div>
    </div>
  )
}
